import {
  AlertOctagon,
  ScrollText,
  PlaneTakeoff,
  CalendarDays,
  Umbrella,
  TimerReset,
  Plane,
  FolderArchive,
  FileCheck,
  MessageCircle,
} from "lucide-react";
import { CAPABILITIES } from "../mock";
import { useReveal } from "../hooks/useReveal";

const ICONS = {
  AlertOctagon,
  ScrollText,
  PlaneTakeoff,
  CalendarDays,
  Umbrella,
  TimerReset,
  Plane,
  FolderArchive,
  FileCheck,
  MessageCircle,
};

const CapabilityCard = ({ c, idx }) => {
  const Icon = ICONS[c.icon] || Plane;
  const ref = useReveal();
  return (
    <div
      ref={ref}
      data-testid={`capability-${idx}`}
      className="reveal group relative bg-[#121A33]/50 backdrop-blur-sm border border-[#2A3451] hover:border-[#C19A5D]/60 hover:-translate-y-1 transition-all duration-500 p-7"
      style={{ transitionDelay: `${(idx % 5) * 60}ms` }}
    >
      <span className="absolute top-0 left-0 h-3 w-3 border-t border-l border-[#C19A5D]/0 group-hover:border-[#C19A5D] transition-colors duration-500" />
      <span className="absolute bottom-0 right-0 h-3 w-3 border-b border-r border-[#C19A5D]/0 group-hover:border-[#C19A5D] transition-colors duration-500" />

      <div className="h-11 w-11 border border-[#C19A5D]/40 bg-[#0A1128] flex items-center justify-center mb-6">
        <Icon className="h-5 w-5 text-[#C19A5D]" strokeWidth={1.25} />
      </div>

      <h3 className="font-heading text-lg sm:text-xl font-semibold tracking-tight leading-snug mb-3">
        {c.title}
      </h3>
      <p className="text-sm text-white/65 font-body leading-relaxed">
        {c.description}
      </p>
    </div>
  );
};

export const Capabilities = () => {
  const ref = useReveal();
  return (
    <section
      id="capabilities"
      data-testid="capabilities-section"
      className="relative py-28 lg:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div ref={ref} className="reveal max-w-3xl mb-16">
          <span className="overline">Portal capabilities</span>
          <h2 className="font-heading mt-4 text-4xl sm:text-5xl font-semibold tracking-tight leading-[1.05]">
            Every capability your operation
            <br />
            <span className="gold-text">actually runs on.</span>
          </h2>
          <p className="mt-6 text-white/65 text-lg leading-relaxed">
            Ten purpose-built modules, all integrated into a single role-scoped portal — no
            stitched-together spreadsheets, no parallel systems.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {CAPABILITIES.map((c, i) => (
            <CapabilityCard key={c.title} c={c} idx={i} />
          ))}
        </div>
      </div>
    </section>
  );
};
